module.exports = __webpack_public_path__ + "img/brush-blue.bed6877f.png";